import styled from 'styled-components';

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 500px;
  padding: 0 5px;

  @media screen and (max-width: 766px) {
    max-width: 420px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;
  width: 100%;
  margin-bottom: 40px;

  > h3 {
    width: 85%;
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 30px;
    text-align: center;
    color: ${props => props.theme.colors.greyDarker};

    strong {
      color: ${props => props.theme.colors.mainColor};
    }
  }

  p {
    width: 85%;
    font-size: 16px;
    text-align: center;
    color: ${props => props.theme.colors.grey02}
  }

  span {
    width: 90%;
    font-size: 18px;
    text-align: center;
    color: ${props => props.theme.colors.greyDarker};
    font-weight: 550;
  }
`

export const Line = styled.div`
  width: 65%;
  height: 1px;
  margin: 30px auto;
  background-color: ${props => props.theme.colors.greyLighter};
`
